import React, { Component } from 'react';
import classNames from 'classnames';
import Tooltip from '../Tooltip';
import HotKeys from "../HotKeys";
import { getMultiLang, debounce, throttle, isBooleanType, isFunction, PubSub, getGlobalStorage, setGlobalStorage, getAppReqParam, pageTo } from '@platform/api';

require('./dragWidth.less');

// 左右分栏展开收起变化,表格重新计算标识
const PUBLISHFORMRESIZE = 'dragWidthComExpand';

export default class DragWidthCom extends Component {
    constructor(props) {
        super(props);
        this.mouseDown = false;
        let newExpandFlag = isBooleanType(this.props.defaultExpandFlag) ? this.props.defaultExpandFlag : true;
        // false 不显示中间线  true 显示中间线
        let newShowDragLine = isBooleanType(this.props.showDragLine) ? this.props.showDragLine : true;
        this.state = {
            expandFlag: newExpandFlag,
            tabActiveKey: this.props.tabActiveKey,
            showDragLine: newShowDragLine,
            json: {
                index_000: "展开图标",
                index_001: "收起图标",
            },
            LangData: null,
            defLeftWidth: this.props.defLeftWid ?? '150px',
        };
        this.expandSideBox = this.expandSideBox.bind(this);
        this.getRelationCode();
        this.defaultExpandFlag = this.props.defaultExpandFlag;
    }

    bindFlexDOM = dom => {
        this.divDom = dom;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.defLeftWid !== this.props.defLeftWidth && !this.setDefWidthFlag){
            if (!this.box) {
                // 传入新的宽度，使用新的宽度，不走缓存
                this.setState({ defLeftWidth: nextProps.defLeftWid });
            }else{
                let { leftMinWid = '50px', defLeftWid = '150px' } = nextProps;
                if(defLeftWid === 'auto'){
                    this.setState({ defLeftWidth: defLeftWid });
                }else{
                    let boxWidth = this.box?.getBoundingClientRect()?.width;
                    if (boxWidth) {
                        let defLeftWidth = typeof (defLeftWid) === 'string' ? defLeftWid.includes('%') ? boxWidth / 100 * parseInt(defLeftWid.replace('%', '')) : parseInt(defLeftWid) : parseInt(defLeftWid);
                        let leftMinWidth = typeof (leftMinWid) === 'string' ? leftMinWid.includes('%') ? boxWidth / 100 * parseInt(leftMinWid.replace('%', '')) : parseInt(leftMinWid) : parseInt(leftMinWid);
                        let leftDomWidth = defLeftWidth > leftMinWidth ? defLeftWidth : leftMinWidth;
                        // 传入新的宽度，使用新的宽度，不走缓存
                        this.setState({ defLeftWidth: leftDomWidth });
                    }
                    
                }
            }
        }
        if (isBooleanType(nextProps.expandFlag) && nextProps.expandFlag !== this.state.expandFlag) {
            this.setState({ expandFlag: nextProps.expandFlag });
        }
        if (nextProps.tabActiveKey !== this.props.tabActiveKey) {
            this.setState({ tabActiveKey: nextProps.tabActiveKey });
        }
        if (nextProps.showDragLine !== this.props.showDragLine) {
            this.setState({ showDragLine: nextProps.showDragLine });
        }
        if (nextProps.maxFlag !== this.state.maxFlag) {
            if (nextProps.maxFlag === false && this.state.maxFlag === true && this.divDom) {
                // 最大化还原时，需要先减去拖拽的线的宽度，避免在render时flex布局抖动
                this.divDom.style.width = 'calc(100% - 4px)';
                setTimeout(() => {
                    this.setState({ maxFlag: nextProps.maxFlag });
                }, 200);
            } else {
                this.setState({ maxFlag: nextProps.maxFlag });
            }
        }
    }
    UNSAFE_componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'contains_dragWidth', callback });
    }
    componentDidMount() {
        if (this.divDom) {
            this.clientWid = this.divDom.clientWidth;
        }
        let { usePosition, leftDom, rightDom, aside = 'left' } = this.props;
        // 在展开收起动画结束后取通知表单重新渲染宽度
        this.box.addEventListener('transitionend', this.publishFormResize);
        window.addEventListener('unload', this.beforeunloadListener);
        this.onMouseDown.call(this);
        let callback = () => {
            if ((aside === 'left' && leftDom) || (aside === 'right' && rightDom)) {
                usePosition && this.getDefLeftWidth();
            }
        };
        this.getExpandStorage(callback);
    }
    componentDidUpdate(prevProps, prevState) {
        this.onMouseDown.call(this);
        // this.setTabsPosition(prevState);
        let { usePosition, leftDom, rightDom, aside = 'left' } = this.props;
        let callback = () => {
            if ((aside === 'left' && leftDom) || (aside === 'right' && rightDom)) {
                usePosition && this.getDefLeftWidth();
            }
        };
        this.getExpandStorage(callback);
    }
    componentWillUnmount() {
        this.beforeunloadListener();
        this.box.removeEventListener('transitionend', this.publishFormResize);
        window.removeEventListener('unload', this.beforeunloadListener);
        document.removeEventListener('mousemove', this.handleMouseMove);

        document.removeEventListener('mouseup', this.handleMouseUp);
        if (this.spanDom) {
            this.spanDom.removeEventListener('mousedown', this.handleMouseDown);
        }
    }

    getDefLeftWidth = () => {
        let { leftMinWid = '50px' } = this.props;
        if (this.drawerDom.style.width) { return; }
        if (!this.box) { return false; }
        let boxWidth = this.box?.getBoundingClientRect()?.width;
        let { defLeftWidth } = this.state;
        defLeftWidth = typeof (defLeftWidth) === 'string' ? defLeftWidth.includes('%') ? boxWidth / 100 * parseInt(defLeftWidth.replace('%', '')) : parseInt(defLeftWidth) : parseInt(defLeftWidth);
        let leftMinWidth = typeof (leftMinWid) === 'string' ? leftMinWid.includes('%') ? boxWidth / 100 * parseInt(leftMinWid.replace('%', '')) : parseInt(leftMinWid) : parseInt(leftMinWid);
        let leftDomWidth = defLeftWidth > leftMinWidth ? defLeftWidth : leftMinWidth;
        this.drawerDom.style.width = leftDomWidth + 'px';
    }

    publishFormResize = () => {
        // 通知表单重新计算
        PubSub.publish(PUBLISHFORMRESIZE);
    }
    setTabsPosition = prevState => {
        if (prevState.expandFlag !== this.state.expandFlag && !!this.state.expandFlag) {
            if (this.divDom) {
                const tabs = this.divDom.querySelector('.nc-tabs');
                if (tabs) {
                    let prePosition = tabs.style.position;
                    let preOverflow = this.divDom.style.overflow;
                    tabs.style.position = 'absolute';
                    this.divDom.style.overflow = 'hidden';
                    setTimeout(() => {
                        tabs.style.position = prePosition;
                        this.divDom.style.overflow = preOverflow;
                    }, 400);
                }

            }
        }
    }

    getClientWidth() {
        if (this.divDom) {
            this.clientWid = this.divDom.clientWidth;
        }
    }

    handleMouseMove = event => {
        //e.stopPropagation();
        if (this.mouseDown && this.divDom) {
            let { aside = "left", onDragMove, maxDragWidth = "all", minDragWidth, leftMinWid = '50px', leftMaxWid, usePosition = false } = this.props;
            this.box.classList.add('dragWidthSelect');
            // let leftDom = this.box.querySelector('.dragWidthCom_left');
            // let rightDom = this.box.querySelector('.dragWidthCom_right');
            // leftDom && (leftDom.style.userSelect = "none");
            // rightDom && (rightDom.style.userSelect = "none");
            // fix bug  IE  e.x !== e.clientx  ie  
            let wid = 0;
            let boxWidth = this.box.clientWidth;
            let newLeftMaxWid = typeof (leftMaxWid) === 'string' ? leftMaxWid.includes('%') ? boxWidth / 100 * parseFloat(leftMaxWid.replace('%', '')) : parseFloat(leftMaxWid) : parseFloat(leftMaxWid);
            let maxCanDrag = newLeftMaxWid ? newLeftMaxWid : maxDragWidth === "all" ? this.box.clientWidth - 20 : this.box.clientWidth / 2;
            let newLeftMinWid = typeof (leftMinWid) === 'string' ? leftMinWid.includes('%') ? boxWidth / 100 * parseFloat(leftMinWid.replace('%', '')) : parseFloat(leftMinWid) : parseFloat(leftMinWid);
            let minWidth = minDragWidth || newLeftMinWid;
            // 方向不一样，需要根据方向做加减法
            if (aside === "left") {
                wid = this.clientWid + (event.clientX - this.beginX);
            } else if (aside === "right") {
                wid = this.clientWid + (this.beginX - event.clientX);
            }
            if (wid >= maxCanDrag) {
                this.divDom.style.width = maxCanDrag + 'px';
                usePosition && (this.drawerDom.style.width = maxCanDrag + 'px');
            } else if (wid <= minWidth) {
                this.divDom.style.width = minWidth + 'px';
                usePosition && (this.drawerDom.style.width = minWidth + 'px');
            } else {
                this.divDom.style.width = wid + 'px';
                usePosition && (this.drawerDom.style.width = wid + 'px');
            }
            if (isFunction(onDragMove)) {
                throttle(onDragMove.bind(this, this.divDom.style.width, event), 1000)();
            }

        }
    };

    handleMouseUp = event => {
        if (this.mouseDown) {
            // 拖拽改变宽度， setDefWidthFlag 设置为true
            this.setDefWidthFlag = true;
            this.mouseDown = false;
            this.box.classList.remove('dragWidthSelect');
            // let leftDom = this.box.querySelector('.dragWidthCom_left');
            // let rightDom = this.box.querySelector('.dragWidthCom_right');
            // leftDom && (leftDom.style.userSelect = "none");
            // rightDom && (rightDom.style.userSelect = "none");
            if (this.divDom) {
                this.clientWid = this.divDom.clientWidth;
            }
            this.maskRightDom && (this.maskRightDom.style.display = 'none');
            this.maskLeftDom && (this.maskLeftDom.style.display = 'none');

            isFunction(this.props.onDragStop) && this.props.onDragStop(this.divDom?.style.width, event);
            this.setState({ defLeftWidth: this.divDom.clientWidth + 'px' }, () => {
                // 把伸缩的动画样式加回来
                this.divDom && this.divDom.classList.add('clickWidthCom_transition');
            });
        }
    };

    handleMouseDown = event => {
        // draggable 默认开启拖拽
        let { draggable = true } = this.props;
        if (!draggable) { return; }
        if (!this.state.expandFlag) { return; }
        if (this.divDom) {
            this.clientWid = this.divDom.clientWidth;
        }
        this.beginX = event.clientX;
        this.mouseDown = true;
        isFunction(this.props.onMouseDown) && this.props.onMouseDown(event);
        // 加个遮罩 应对  iframe的情况
        this.maskRightDom && (this.maskRightDom.style.display = 'block');
        this.maskLeftDom && (this.maskLeftDom.style.display = 'block');
        // 把伸缩的动画样式删除
        this.divDom && this.divDom.classList.remove('clickWidthCom_transition');
    };

    onMouseDown() {
        // aside "right" 右侧宽度自适应 "left" 左侧宽度自适应
        let { aside = "left", onDragMove, maxDragWidth = "all", minDragWidth } = this.props;
        document.addEventListener('mousemove', this.handleMouseMove);

        document.addEventListener('mouseup', this.handleMouseUp);
        if (this.spanDom) {
            this.spanDom.addEventListener('mousedown', this.handleMouseDown);
        }
    }

    expandSideBox() {
        let { expandFlag } = this.state;
        let newExpandFlag = !expandFlag;
        this.clickExpandFlag = true;
        this.setState({ expandFlag: newExpandFlag }, () => {
            // NCC-302720 动画结束后更新下组件，通知到表格计算滚动条的位置
            let { asyncExpand = true } = this.props;
            if (asyncExpand) {
                setTimeout(() => {
                    isFunction(this.props.onExpand) && this.props.onExpand(newExpandFlag, "horizontal");
                }, 300);
            } else {
                isFunction(this.props.onExpand) && this.props.onExpand(newExpandFlag, "horizontal");
            }
        });
    }

    getExpandStorage = callback => {
        let { appCode = this.appCode, pageCode = this.pageCode, moduleId, useCache = true, defaultExpandFlag, cacheWidth } = this.props;
        // useCache 启用缓存，默认true
        if (!useCache || this.clickExpandFlag || this.setDefWidthFlag) { return; }
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let localStorage = 'customer_drag_width';
        let dragWidthtStorage = JSON.parse(getGlobalStorage('localStorage', localStorage)) || {};
        let drag_width_localStorage = dragWidthtStorage[appCode + '_' + pageCode + '_' + moduleId + '_' + userid];
        if (drag_width_localStorage) {
            let { expandFlag: storageExpandFlag, defLeftWidth: storageDefLeftWidth } = drag_width_localStorage;
            let { expandFlag, defLeftWidth } = this.state;
            storageDefLeftWidth = storageDefLeftWidth || defLeftWidth;
            if (cacheWidth && (storageExpandFlag !== expandFlag || storageDefLeftWidth !== defLeftWidth)) {
                this.setState({ 
                    expandFlag: storageExpandFlag,
                    defLeftWidth: storageDefLeftWidth,
                }, ()=>callback());
            }else if (storageExpandFlag !== expandFlag){
                this.setState({ expandFlag: storageExpandFlag }, ()=>callback());
            }
        } else if (!drag_width_localStorage && defaultExpandFlag !== this.defaultExpandFlag) {
            this.defaultExpandFlag = defaultExpandFlag;
            this.setState({ expandFlag: defaultExpandFlag }, ()=>callback());
        }
    }

    beforeunloadListener = () => {
        // 加了一个字段，是否缓存宽度，默认false，四向分栏会传过来true
        let { useCache = true, cacheWidth = false } = this.props;
        // useCache 启用缓存，默认true
        if (!useCache) { return; }
        // 组件销毁前缓存当前 moduleId 的展开收起状态，以及当前设置的高度
        let { expandFlag, defLeftWidth } = this.state;
        let dragWidthStorage = { expandFlag };
        dragWidthStorage = cacheWidth? { defLeftWidth, expandFlag } : { expandFlag };
        let { appCode = this.appCode, pageCode = this.pageCode, moduleId } = this.props;
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let localStorage = 'customer_drag_width';
        let drag_width_storage = JSON.parse(getGlobalStorage('localStorage', localStorage)) || {};
        drag_width_storage[appCode + '_' + pageCode + '_' + moduleId + '_' + userid] = dragWidthStorage;

        if (expandFlag === this.props.expandFlag && (!dragWidthStorage || dragWidthStorage?.expandFlag === expandFlag) && !this.clickExpandFlag) {
            // 如果没有任何操作，不缓存
            return;
        }

        try {
            setGlobalStorage('localStorage', localStorage, JSON.stringify(drag_width_storage));
        } catch (e) {
            console.log('浏览器localStorage容量不足');
        }
    }

    getRelationCode = () => {
        let appReqParam = getAppReqParam();
        this.pageCode = appReqParam.pagecode;
        this.appCode = appReqParam.appcode;
    }

    render() {
        let {
            defLeftWid = '150px',
            leftMinWid = '50px',
            aside = "left", // "right" 侧边栏在右侧 "left" 侧边栏在左侧
            leftDom,
            rightDom,
            showExpandBtn = true, // false 不显示展开收起按钮  true 显示展开收起按钮 
            // showDragLine = true, 
            // maxFlag = false, // 最大化标识
            className = '',
            draggable = true,
            style = {},
            bottomClassName,
            expandKeyboard = ["Alt+Ctrl+]"],
            showHorArea,
            visible = true,
            forceRightVisible = true,
            usePosition = false, // 四向分栏布局使用绝对定位优化动画效果
        } = this.props;
        // 解决 领域传 defLeftWid="150px" leftMinWid = "300px" 的问题
        // let newDefLeftWid = parseInt(defLeftWid) > parseInt(leftMinWid) ? defLeftWid : leftMinWid;
        let { expandFlag, json, maxFlag, showDragLine, defLeftWidth } = this.state;
        let bottomStyle = bottomClassName ? { background: 'transparent' } : {};

        if (!Number.isNaN(Number(defLeftWid))) {
            defLeftWid = Number(defLeftWid) + "px";
        }
        if (!Number.isNaN(Number(leftMinWid))) {
            leftMinWid = Number(leftMinWid) + "px";
        }

        const expandKeyboardStr = ' ( ' + (Array.isArray(expandKeyboard) ? expandKeyboard.join(',') : expandKeyboard) + ' ) ';
        if (visible === false) {
            return null;
        }
        return (
            <div
                className={`dragWidthCom ${className}`}
                ref={box => {
                    this.box = box;
                }}
                style={{ ...style, ...bottomStyle }}
            >
                <div
                    className={
                        classNames(
                            'dragWidthCom_left',
                            {
                                dragWidthComFlex_left: aside === "right",
                                clickWidthCom_transition: aside === "left" && this.clickExpandFlag,
                                clickWidthCom_min: (aside === "left" && !expandFlag),
                                dragWidthComFlex_left_expand: (aside === "right" && expandFlag),
                            },
                        )
                    }
                    style={aside === "left" ? (maxFlag ? { width: '100%', ...bottomStyle } : { width: defLeftWidth, minWidth: expandFlag ? leftMinWid : 0, ...bottomStyle }) : { ...bottomStyle }}
                    ref={aside === "left" ? this.bindFlexDOM : null}
                    id='dragWidthCom_left'
                >
                    <div className="dragWidthCom_mask" ref={mask => { this.maskLeftDom = mask; }} />
                    {
                        leftDom ?
                            aside === 'left' && usePosition ?
                                <div className='dragWidthCom_drawer' ref={dom => { this.drawerDom = dom; }}>
                                    {leftDom ? React.cloneElement(leftDom, { expandFlag: showDragLine && expandFlag }) : null}
                                </div>
                                : <div style={{ height:'100%', overflow:'auto', display: 'flex', flexDirection: 'column' }} >{React.cloneElement(leftDom, { expandFlag: showDragLine && expandFlag })}</div>
                            : null

                    }
                </div>
                {!maxFlag && showDragLine &&
                    <div
                        className={
                            classNames(
                                'dragWidthCom_line',
                                draggable ? '' : 'dragWidthCom_lines_resize',
                                // 如果是在右边 3px边距+1px线 如果是在右边左边1px线，没有间距
                                aside === "left" ? 'dragWidthCom_line_left' : 'dragWidthCom_line_right',
                            )
                        }
                    >
                        <div className='dragWidthCom_lines_wrapper'
                            ref={span => {
                                this.spanDom = span;
                            }}
                        >
                            <div

                                className={
                                    classNames(
                                        'dragWidthCom_lines',
                                        aside === "right" ? 'dragWidthComRight_lines' : '',
                                    )
                                }
                            />
                        </div>
                        {showExpandBtn &&
                            (<>
                                <HotKeys
                                    keyMap={{ handleExpand: Array.isArray(expandKeyboard) && expandKeyboard.length === 0 ? [] : ["Alt+Ctrl+]", "Alt+command+]"] }}
                                    handlers={{
                                        handleExpand: () => {
                                            this.expandSideBox();
                                        },
                                    }}
                                    className="dragwidth-hotkeys-wrapper"
                                    focused={true}
                                    attach={document.body}
                                    display="inline"
                                >
                                </HotKeys>
                                <Tooltip
                                    placement={expandFlag ? "top" : "left"}
                                    overlay={expandFlag ? json.index_001 + expandKeyboardStr : json.index_000 + expandKeyboardStr}
                                    delayHide={1}
                                    delayShow={500}
                                    trigger={'hover'}
                                >
                                    <div
                                        className={
                                            classNames(
                                                'drag-width-icon',
                                                {
                                                    'drag-width-icon-left-expend': aside === "left" && expandFlag,
                                                    'drag-width-icon-right-expend': aside === "right" && expandFlag,
                                                    'drag-width-icon-right': aside === "right" && !expandFlag,
                                                    'drag-width-icon-left': aside === "left" && !expandFlag,
                                                },
                                            )}
                                        onClick={this.expandSideBox}
                                    ><i className="icon iconfont icon-yewucebian"></i></div>
                                </Tooltip>
                            </>)
                        }
                    </div>
                }
                <div
                    className={
                        classNames(
                            'dragWidthCom_right',
                            {
                                "dragWidthComFlex_right": aside === "right",
                                "clickWidthCom_transition": aside === "right" && this.clickExpandFlag,
                                "clickWidthCom_right": (aside === "right" && (!expandFlag || showHorArea === false)),
                                'dwc-right-hidden': !forceRightVisible,
                            },
                        )
                    }
                    id="scroll_container"
                    style={aside === "right" ? (maxFlag ? { width: '100%' } : { width: defLeftWidth, minWidth: expandFlag ? leftMinWid : 0 }) : {}}
                    ref={aside === "right" ? this.bindFlexDOM : null}
                >
                    <div className="dragWidthCom_mask" ref={mask => { this.maskRightDom = mask; }} />
                    {
                        rightDom ?
                            aside === 'right' && usePosition ?
                                <div className='dragWidthCom_drawer' ref={dom => { this.drawerDom = dom; }}>
                                    {rightDom ? React.cloneElement(rightDom, { expandFlag: showDragLine && expandFlag }) : null}
                                </div>
                                : React.cloneElement(rightDom, { expandFlag: showDragLine && expandFlag })
                            : null
                    }
                </div>
            </div >
        );
    }
}
